import React, { useContext, useState, useEffect } from 'react'
import './review.css'

const ReviewComponent = (props) => {
    const review = props.data?.[0]
    console.log('props reviews ', review)
    useEffect(() => {
        if (review.enable) {
            const scriptTag = document.createElement('script')

            scriptTag.src = '//embed.broadly.com/include.js'
            scriptTag.async = true
            scriptTag.setAttribute('data-url', `/${review.apiKey}/reviews`)

            let reviewStream = document.getElementById('review-stream')
            reviewStream.appendChild(scriptTag)
            return () => {
                reviewStream.removeChild(scriptTag)
            }
        }
    }, [review.enable])

    return (
        <div>
            {review.enable ? (
                <div id="review-stream" className="container review-stream review-stream-div"></div>
            ) : (
                ''
            )}
        </div>
    )
}
export default ReviewComponent
